import { ASSIGN_SEAT, REQUEST_SEAT } from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes';
export const getHasSeatPurchaseMotions = purchaseMotions => {
  return purchaseMotions.includes(REQUEST_SEAT) || purchaseMotions.includes(ASSIGN_SEAT);
};